import { useState } from 'react';
import produce from 'immer';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import { QaApplication, Status } from '../../types/QaErrors';
import { getApps, getErrorsCode } from '../../services/scriptConfiguration.service';

export type FiltersState = {
  applications: QaApplication[];
  errorsCodes: number[];
  statuses: Status[];
};

const initialState: FiltersState = {
  applications: [],
  errorsCodes: [],
  statuses: Object.values(Status),
};

const useFiltersListFetch = (appId: string, siteCode: string, scriptName: string) => {
  const [state, setState] = useState<FiltersState>(initialState);

  useAsyncEffect(async () => {
    try {
      const [applications, errorsCodes] = await Promise.all([
        getApps({ siteCode, scriptName }),
        getErrorsCode({ siteCode, scriptName, appId }),
      ]);
      setState(
        produce((draft: FiltersState) => {
          draft.applications = applications;
          draft.errorsCodes = errorsCodes;
        })
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  return state;
};

export default useFiltersListFetch;
